module.exports = __webpack_public_path__ + "static/img/AIGC视频-品牌宣传片.5e3b736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10009/AIGC视频-品牌宣传片.png
// module id = CPRC
// module chunks = 1